import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";
import { DetailsByCustomerActionContext } from "./DetailsByCustomerActionContext";

function useGet(modelConfig: any) {
  const { setElement } = useContext(DetailsByCustomerActionContext);
  const errorHandler = useErrorHandler();
  const { setChanged } = useContext(ChangeDectionContext);

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get(modelConfig.endpoint + "/findByCustomerId", id)
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setTimeout(() => {
          setChanged(false, data);
        }, 3000);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
